import { Button } from 'antd';
import { t } from 'i18next';
import React from 'react';
import usePermission from '../../../../hooks/usePermission';

export default function Platform({ setPlatform, platform, loading }) {
    const deactive = '#65707A';
    const active = '#7B67FB';

    const { isAuditor } = usePermission();

    return (
        <div className="flex items-center justify-between">
            <div className="flex space-x-2 items-center">
                <button
                    type="button"
                    onClick={() => setPlatform('Desktop')}
                    className={`rounded-lg cursor-pointer ${
                        platform === 'Desktop'
                            ? 'border-[1px] border-solid border-[#7B67FB] bg-[#F5F0FF]'
                            : 'border-[1px] border-solid border-[#FFFF] bg-[#F9F9F9]'
                    } w-20 h-16`}
                >
                    <div
                        className="text-center items-center pt-3"
                        style={{
                            color: platform === 'Desktop' ? active : deactive,
                        }}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                opacity="0.3"
                                d="M22.25 3.35C22.25 2.675 21.575 2 20.9 2H3.35C2.675 2 2 2.675 2 3.35V16.175H22.25V3.35Z"
                                fill={
                                    platform === 'Desktop' ? active : deactive
                                }
                            />
                            <path
                                opacity="0.3"
                                d="M2 16.1748V17.5248C2 18.1998 2.675 18.8748 3.35 18.8748H20.9C21.575 18.8748 22.25 18.1998 22.25 17.5248V16.1748H2Z"
                                fill={
                                    platform === 'Desktop' ? active : deactive
                                }
                            />
                            <path
                                opacity="0.3"
                                d="M9.42461 19.55C9.42461 20.9 8.07461 20.9 6.72461 20.9H17.5246C16.1746 20.9 14.8246 20.9 14.8246 19.55V18.875H9.42461V19.55Z"
                                fill={
                                    platform === 'Desktop' ? active : deactive
                                }
                            />
                            <path
                                d="M3.34961 3.3501H20.8996V14.8251H3.34961V3.3501Z"
                                fill={
                                    platform === 'Desktop' ? active : deactive
                                }
                            />
                            <g opacity="0.3">
                                <path
                                    d="M12.1236 17.8283C12.31 17.8283 12.4611 17.6772 12.4611 17.4908C12.4611 17.3044 12.31 17.1533 12.1236 17.1533C11.9372 17.1533 11.7861 17.3044 11.7861 17.4908C11.7861 17.6772 11.9372 17.8283 12.1236 17.8283Z"
                                    fill="#65707A"
                                />
                                <path
                                    d="M6.72363 20.8999H17.5236V22.2499H6.72363V20.8999Z"
                                    fill="#65707A"
                                />
                            </g>
                        </svg>

                        <div className="font-medium text-10">
                            {t('Desktop')}
                        </div>
                    </div>
                </button>
                <button
                    type="button"
                    onClick={() => setPlatform('Tablet')}
                    className={`rounded-lg cursor-pointer ${
                        platform === 'Tablet'
                            ? 'border-[1px] border-solid border-[#7B67FB] bg-[#F5F0FF]'
                            : 'border-[1px] border-solid border-[#FFFF] bg-[#F9F9F9]'
                    } w-20 h-16`}
                >
                    <div
                        className="text-center items-center pt-3"
                        style={{
                            color: platform === 'Tablet' ? active : deactive,
                        }}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                opacity="0.3"
                                d="M3.30566 21.2391V2.76083C3.30566 1.56517 4.28392 0.586914 5.47958 0.586914H18.5231C19.7187 0.586914 20.697 1.56517 20.697 2.76083V21.2391C20.697 22.4347 19.7187 23.413 18.5231 23.413H5.47958C4.28392 23.413 3.30566 22.4347 3.30566 21.2391Z"
                                fill={platform === 'Tablet' ? active : deactive}
                            />
                            <path
                                d="M18.5235 2.21729H5.48C5.15391 2.21729 4.93652 2.43468 4.93652 2.76076V19.6086C4.93652 19.9347 5.15391 20.1521 5.48 20.1521H18.5235C18.8496 20.1521 19.067 19.9347 19.067 19.6086V2.76076C19.067 2.43468 18.8496 2.21729 18.5235 2.21729Z"
                                fill={platform === 'Tablet' ? active : deactive}
                            />
                            <path
                                d="M10.3691 21.2393H13.63V22.3262H10.3691V21.2393Z"
                                fill={platform === 'Tablet' ? active : deactive}
                            />
                        </svg>

                        <div className="font-medium text-10">{t('Tablet')}</div>
                    </div>
                </button>
                <button
                    type="button"
                    onClick={() => setPlatform('Mobile')}
                    className={`rounded-lg cursor-pointer ${
                        platform === 'Mobile'
                            ? 'border-[1px] border-solid border-[#7B67FB] bg-[#F5F0FF]'
                            : 'border-[1px] border-solid border-[#FFFF] bg-[#F9F9F9]'
                    } w-20 h-16`}
                >
                    <div
                        className="text-center items-center pt-3"
                        style={{
                            color: platform === 'Mobile' ? active : deactive,
                        }}
                    >
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g clipPath="url(#clip0_8467_377565)">
                                <path
                                    opacity="0.3"
                                    d="M16.4636 3H7.53422C7.15539 3.00015 6.79211 3.15069 6.5242 3.41854C6.2563 3.68639 6.10569 4.04964 6.10547 4.42847V19.5724C6.10584 19.9512 6.2565 20.3143 6.52437 20.5821C6.79224 20.85 7.15543 21.0005 7.53422 21.0008H16.4636C16.8425 21.0005 17.2057 20.8499 17.4737 20.5821C17.7417 20.3143 17.8925 19.9512 17.8932 19.5724V4.43072C17.8928 4.05181 17.742 3.68856 17.4739 3.42073C17.2059 3.15291 16.8425 3.0024 16.4636 3.00225"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                                <path
                                    opacity="0.7"
                                    d="M15.5378 4.08902H8.46156C8.16144 4.08901 7.87357 4.20804 7.66109 4.42C7.44861 4.63195 7.32887 4.91952 7.32812 5.21964V17.2197C7.32872 17.5199 7.44842 17.8076 7.66093 18.0195C7.87344 18.2315 8.1614 18.3505 8.46156 18.3504H15.5378C16.1622 18.3504 16.6684 17.8413 16.6684 17.2197V5.21852C16.6684 4.59414 16.1608 4.08789 15.5378 4.08789"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                                <path
                                    d="M11.8014 4.08845H8.46156C8.16144 4.08845 7.87357 4.20748 7.66109 4.41943C7.44861 4.63139 7.32887 4.91896 7.32812 5.21908V17.2192C7.32872 17.5193 7.44842 17.807 7.66093 18.019C7.87344 18.231 8.1614 18.3499 8.46156 18.3498H15.5378C15.7665 18.3498 15.9777 18.2798 16.1554 18.1645C13.1469 14.2455 11.5365 8.97742 11.8022 4.08789"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                                <path
                                    d="M12.9288 19.7039C12.9288 20.215 12.5137 20.6315 12.0015 20.6315C11.4893 20.6315 11.0742 20.2152 11.0742 19.7039C11.0742 19.1926 11.4893 18.7764 12.0015 18.7764C12.5137 18.7764 12.9288 19.1926 12.9288 19.7039Z"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                                <path
                                    d="M9.3566 19.7042C9.35849 19.7944 9.34236 19.8841 9.30916 19.968C9.27595 20.0519 9.22633 20.1284 9.16321 20.1929C9.10009 20.2574 9.02473 20.3086 8.94155 20.3437C8.85837 20.3787 8.76904 20.3967 8.6788 20.3968C8.58855 20.3968 8.4992 20.3789 8.41598 20.344C8.33275 20.3091 8.25733 20.2579 8.19413 20.1935C8.13093 20.1291 8.08122 20.0527 8.0479 19.9688C8.01459 19.8849 7.99835 19.7953 8.00013 19.705C8.00363 19.5275 8.07657 19.3585 8.2033 19.2342C8.33002 19.1098 8.50043 19.0401 8.67795 19.04C8.85548 19.0399 9.02597 19.1094 9.15285 19.2336C9.27973 19.3577 9.35288 19.5267 9.3566 19.7042Z"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                                <path
                                    d="M14.6487 19.7035C14.6461 19.7942 14.6617 19.8845 14.6946 19.969C14.7275 20.0536 14.777 20.1307 14.8403 20.1957C14.9035 20.2608 14.9791 20.3125 15.0627 20.3479C15.1463 20.3832 15.2361 20.4014 15.3268 20.4014C15.4175 20.4014 15.5073 20.3832 15.5909 20.3479C15.6745 20.3125 15.7501 20.2608 15.8134 20.1957C15.8766 20.1307 15.9261 20.0536 15.959 19.969C15.9919 19.8845 16.0075 19.7942 16.0049 19.7035C16.0049 19.5236 15.9335 19.3512 15.8063 19.224C15.6791 19.0968 15.5067 19.0254 15.3268 19.0254C15.147 19.0254 14.9745 19.0968 14.8473 19.224C14.7202 19.3512 14.6487 19.5236 14.6487 19.7035Z"
                                    fill={
                                        platform === 'Mobile'
                                            ? active
                                            : deactive
                                    }
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_8467_377565">
                                    <rect
                                        width="18"
                                        height="18"
                                        fill="white"
                                        transform="translate(3 3)"
                                    />
                                </clipPath>
                            </defs>
                        </svg>

                        <div className="font-medium text-10">{t('Mobile')}</div>
                    </div>
                </button>
            </div>
            <Button
                disabled={isAuditor}
                loading={loading}
                size="large"
                type="primary"
                htmlType="submit"
                className="w-[120px]"
            >
                {t('common.Save')}
            </Button>
        </div>
    );
}
